/** Offline / demo data layer. Enable with `VITE_USE_MOCK=true`. */
export function isMockMode(): boolean {
  return import.meta.env.VITE_USE_MOCK === "true";
}

/** WebSocket URL for {@link RealtimeBootstrap}: mock stream or configured `VITE_WS_URL`. */
export function getBootstrapRealtimeUrl(): string | null {
  if (isMockMode()) {
    return "mock://realtime";
  }
  const u = import.meta.env.VITE_WS_URL;
  return typeof u === "string" && u.trim() ? u.trim() : null;
}
